import { render, staticRenderFns } from "./rpterstdexam.vue?vue&type=template&id=495075bf&"
import script from "./rpterstdexam.vue?vue&type=script&lang=js&"
export * from "./rpterstdexam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports